var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"transition-shadow duration-300 w-full h-64 text-center rounded-lg shadow-lg hover:shadow-xl bg-white"},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }